import { setupEditPanelGroupDialog } from '../reducers/edit_panel_group_dialog';
import { showDialog } from '../reducers/app';
export function editPanelGroup(id) {
    return (dispatch, getState) => {
        const { definitions } = getState();
        const group = definitions.panel_groups.entities[id];
        if (group) {
            dispatch(setupEditPanelGroupDialog({
                id: group.id,
                panel_id: group.panel_id,
                title: group.title,
                ord: group.ord,
            }));
            dispatch(showDialog('group-edit'));
        }
    };
}
